module.exports = __webpack_public_path__ + "img/icon_月.3b4199f8.svg";